import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCaseCycleConfirmationModal = ({
  dropdownElInfo,
  deleteCycleOpen,
  setDeleteCycleOpen,
  setTestCasesToggler
}) => {
  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteCycleOpen(false)
  }

  const handleDeleteCycle = async () => {
    setLoading(true)
    try {
      await PageService.deleteTestCaseCycle(dropdownElInfo.id)
      setTestCasesToggler(prev => !prev)
      setDeleteCycleOpen(false)
      setLoading(false)
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteCycleOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Cycle
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            Are you sure you want to delete this test cycle? This action cannot be undone, and all associated test runs will be removed.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteCycle} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCaseCycleConfirmationModal
